import { useState } from "react";

// ─── helpers ────────────────────────────────────────────────────────────────
const cleanDigits = (val) => val.replace(/\D/g, "");

const normalizeDigits = (val) => {
    let d = cleanDigits(val);

    // remove +61
    if (d.startsWith("61")) d = d.slice(2);

    return d;
};

const formatAustralianPhone = (digits) => {
    if (!digits) return "";

    // mobile
    if (digits.startsWith("0")) {
        if (digits.length <= 4) return digits;
        if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
        return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)}`;
    }

    return digits;
};

const isValidAustralianPhone = (val) => {
    if (!val || !val.trim()) return false;

    let d = normalizeDigits(val);

    return (
        /^04\d{8}$/.test(d) ||   // 0412...
        /^4\d{8}$/.test(d)       // 412...
    );
};

const toE164 = (val) => {
    if (!val || !val.trim()) return null;

    let d = normalizeDigits(val);

    // 0412... → +61412...
    if (d.startsWith("0") && d.length === 10) {
        return "+61" + d.slice(1);
    }

    // 412... → +61412...
    if (d.startsWith("4") && d.length === 9) {
        return "+61" + d;
    }

    return null;
};

// ─── hook ───────────────────────────────────────────────────────────────────
export const useAustralianPhone = (initial = "") => {
    const [value, setValue] = useState(initial);

    const handleChange = (e) => {
        let input = e.target.value;
        let digits = normalizeDigits(input);

        // If starts with 4 → assume missing 0
        if (digits.startsWith("4")) {
            digits = "0" + digits;
        }

        // limit length
        digits = digits.slice(0, 10);

        setValue(formatAustralianPhone(digits));
    };

    const isValid = isValidAustralianPhone(value);

    const getE164 = () => toE164(value);

    const reset = () => setValue("");

    return {
        value,
        setValue,
        handleChange,
        isValid,
        getE164,
        reset,
    };
};